import {types} from './types';

const setGetProviderListAction = (payload) => {
    return {
        type: types.SET_PROVIDER_LIST,
        payload,
      }
}

const setGetSearchListAction = (payload) => {
  return {
    type: types.SET_SEARCH_LIST,
    payload
  }
}

export {
  setGetProviderListAction,
  setGetSearchListAction
}